import { all, fork, put, select, takeLatest } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import qs from 'qs';

// Types
import { SagaIterator } from 'redux-saga';
import { UpdateQueryStringAction, PushWithStoredSearchAction } from './types';

// Actions
// @ts-ignore
import { setSearch, resetSearch } from '../searches';

// Constants
import {
    QUERY_STRING_UPDATE,
    QUERY_STRING_DELETE,
    PUSH_WITH_STORED_SEARCH,
    QUERY_STRING_RESET
} from './constants';

// Selectors
import {
    selectLocationPathname,
    makeSelectQueryString,
    makeSelectQueryStringWhitelist
} from '../../workspaces/react-router-selectors';
// @ts-ignore
import { makeSelectSearch } from '../searches/selectors';


export function* resetQueryString(): SagaIterator {
    // Select Location Pathname
    // @ts-ignore
    const pathname = yield select(selectLocationPathname);

    // Select Query String
    const queryString = yield select(makeSelectQueryStringWhitelist())

    const search = qs.stringify(queryString);

    yield put(
        push({
            pathname,
            search
        })
    );

    yield put(setSearch(pathname, search));
}

export function* updateQueryString(action: UpdateQueryStringAction): SagaIterator {
    // Select Location Pathname
    // @ts-ignore
    const pathname = yield select(selectLocationPathname);

    // Select Query String
    const queryString = yield select(makeSelectQueryString());

    const search = qs.stringify({
        ...queryString,
        ...action.payload
    });

    yield put(
        push({
            pathname,
            search
        })
    );

    yield put(setSearch(pathname, search));
}

export function* watchQueryStringUpdate(): SagaIterator {
    yield takeLatest(QUERY_STRING_UPDATE, updateQueryString);
}

export function* deleteQueryString(): SagaIterator {
    // Select Location Pathname
    // @ts-ignore
    const pathname = yield select(selectLocationPathname);

    yield put(push({ pathname }));

    yield put(resetSearch());
}

export function* watchQueryStringDelete(): SagaIterator {
    yield takeLatest(QUERY_STRING_DELETE, deleteQueryString);
}

export function* watchQueryStringReset(): SagaIterator {
    yield takeLatest(QUERY_STRING_RESET, resetQueryString);
}

export function* pushWithStoredSearch(action: PushWithStoredSearchAction): SagaIterator {
    const pathname = action.payload;

    // Select Search
    const search = yield select(makeSelectSearch(), { namespace: pathname });

    yield put(
        push({
            pathname,
            search
        })
    );
}

export function* watchPushWithStoredSearch(): SagaIterator {
    yield takeLatest(PUSH_WITH_STORED_SEARCH, pushWithStoredSearch);
}

export default function* routerSagas(): SagaIterator {
    yield all([
        fork(watchQueryStringUpdate),
        fork(watchQueryStringDelete),
        fork(watchPushWithStoredSearch),
        fork(watchQueryStringReset)
    ]);
}
